import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { Subject, Subscription, filter, takeUntil } from 'rxjs';
import { SecureStorageService } from './core/services/secure-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';

@Component({ standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',

  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  loginStatus: boolean = false;
  subscriptionTranslateService?: Subscription;
  private readonly _destroying$ = new Subject<void>();

  constructor(
      private broadcastService: MsalBroadcastService, 
      private msalService: MsalService, 
      private route: Router, 
      private translateService: TranslateService,
      private config: PrimeNG,
      private secureStorageService: SecureStorageService,
  ) {

    this.broadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.LOGOUT_SUCCESS),
      )
      .subscribe(async (result: EventMessage) => {
        if (this.msalService.instance.getAllAccounts().length === 0) {

        } else {
          // this.setLoginDisplay();
        }
    });

    this.broadcastService.msalSubject$
    .pipe(
      filter(
        (msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS
        )
      ).subscribe(async (result: EventMessage) => {
        
    });


    this.broadcastService.msalSubject$
    .pipe(
      filter(
          (msg: EventMessage) => msg.eventType === EventType.LOGOUT_SUCCESS)
      ).subscribe((result: EventMessage) => {
          this.secureStorageService.clearData();
    });

    this.broadcastService.inProgress$
    .pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      takeUntil(this._destroying$)
    )
    .subscribe(() => {
        this.setLoginDisplay();
    })
  }

  async setLoginDisplay() {
    this.loginStatus = this.msalService.instance.getAllAccounts().length > 0;

    if(this.loginStatus){
     
      const profile_data = this.msalService.instance.getAllAccounts()[0];
      this.msalService.instance.setActiveAccount(profile_data);
    } else {
      this.route.navigate(['/']);
    }

  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();

    if (this.subscriptionTranslateService) {
      this.subscriptionTranslateService.unsubscribe();
    }
  }

  ngOnInit() {
    this.translateService.setFallbackLang('es');
    this.translateService.use('es');
    this.subscriptionTranslateService = this.translateService
      .stream('primeng')
      .subscribe((data) => {
        this.config.setTranslation(data);
      });
  }

}
